/**
 *
 * BecomeASingerCard
 *
 */
// @ts-nocheck
import * as React from 'react';
import styled from 'styled-components/macro';
import {Button} from "@mui/material";

interface Props {}

export function BecomeASingerCard(props: Props) {
  return <Div>
    <Title>
      Want to sell your music with AI?
    </Title>
    <Description>
      <strong>Get paid to sing</strong> while fans/fellow artists experience your songs in their voice.
    </Description>
    <Description>
      <strong>Reach new audiences</strong> by letting new voices share your music with the world.
    </Description>
    <ActionButton variant="contained" color={"primary"} href={"https://forms.wix.com/f/6933449319412400380"} target={"_blank"}>
      APPLY FOR AN ARTIST PROFILE
    </ActionButton>
  </Div>;
}

const Div = styled.div`
  border-radius: 20px;
  background: #0a051f;
  margin: 20px;
  padding: 40px;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
`;

const Title = styled.div`
  color: #FFF;

  font-family: Raleway;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  padding-bottom: 20px;
`;

const Description = styled.div`
  color: rgba(245, 225, 255, 0.74);

  font-family: Raleway;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  
  margin-bottom: 5px;
`;

const ActionButton = styled(Button)`
  
  margin-top: 20px !important;

`;

